import { render, staticRenderFns } from "./AddStudentUpdateAlbumDialog.vue?vue&type=template&id=15e67303"
import script from "./AddStudentUpdateAlbumDialog.vue?vue&type=script&lang=js"
export * from "./AddStudentUpdateAlbumDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15e67303')) {
      api.createRecord('15e67303', component.options)
    } else {
      api.reload('15e67303', component.options)
    }
    module.hot.accept("./AddStudentUpdateAlbumDialog.vue?vue&type=template&id=15e67303", function () {
      api.rerender('15e67303', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/album/AddStudentUpdateAlbumDialog.vue"
export default component.exports